import {
  Archive,
  CircleCheck,
  Clock3,
  EyeIcon,
  FileCheck,
  OctagonAlert,
} from 'lucide-react';

export const ADVANCED_CREATORS = ['SuperAdmin'];

export const DOCUMENT_TYPES = {
  PRT: { abbr: 'PRT', label: 'Report' },
  QM: { abbr: 'QM', label: 'Quality Manual' },
  SOP: { abbr: 'SOP', label: 'Standard Operating Procedure' },
  WI: { abbr: 'WI', label: 'Work Instruction' },
};

export { CONTROL_DEFAULT_STATE } from './control';

export const YES_NO_BASIC_OPTIONS = [
  {
    label: 'Yes',
    value: 1,
  },
  {
    label: 'No',
    value: 0,
  },
];

export const STATUS_MAP = {
  APPROVED: {
    bgColor: '#fffbeb',
    icon: FileCheck,
    text: 'Approved',
    variant: 'success',
  },
  ARCHIVED: {
    bgColor: '#f8fafc',
    icon: Archive,
    text: 'Archived',
    variant: 'secondary',
  },
  CLOSED: {
    bgColor: '#f0f9ff',
    icon: CircleCheck,
    text: 'Closed',
    variant: 'success',
  },
  DRAFT: {
    bgColor: '#fffbeb',
    icon: Clock3,
    text: 'Draft',
    variant: 'secondary',
  },
  PENDING_ACTION: {
    bgColor: '#ecfdf5',
    icon: EyeIcon,
    text: 'Pending Action',
    variant: 'warning',
  },
  PENDING_EC: {
    bgColor: '#fffbeb',
    icon: Clock3,
    text: 'Pending EC',
    variant: 'warning',
  },
  REJECTED: {
    bgColor: '#fffbeb',
    icon: OctagonAlert,
    text: 'Rejected',
    variant: 'destructive',
  },
  RELEASED: {
    bgColor: '#ecfdf5',
    icon: CircleCheck,
    text: 'Released',
    variant: 'outline',
  },
  RETURNED: {
    bgColor: '#fffbeb',
    icon: OctagonAlert,
    text: 'Returned',
    variant: 'warning',
  },
  REVIEWING: {
    bgColor: '#ecfdf5',
    icon: EyeIcon,
    text: 'Reviewing',
    variant: 'default',
  },
};

export const SECTION_GROUP = {
  INFORMATION: { key: 'information', label: 'Document Information' },
  HISTORY: { key: 'history', label: 'Document History & Approval' },
  CONTENT: { key: 'content', label: 'Content' },
};

export const AUDIT_TRAIL_ROLES = [];
// Populate with role strings (e.g. 'ADMIN', 'AUDITOR') when confirmed.
// Not imported by any component in this feature — defined here for future use only.

// All valid Cognito groups from apps/api/src/config/permissions.js PERMISSION_MATRIX
export const VALID_COGNITO_GROUPS = [
  'User',
  'QA',
  'ProcessOwner',
  'Management',
  'PowerUser',
  'SuperAdmin',
];

export const ADMIN_GROUPS = ['PowerUser', 'SuperAdmin'];
export const ASSIGNABLE_ROLES = VALID_COGNITO_GROUPS;

export const DEPARTMENT_OPTIONS = [
  { label: 'MGT', value: 'MGT' },
  { label: 'QA/QC', value: 'QA/QC' },
  { label: 'Q&W', value: 'Q&W' },
  { label: 'T&H', value: 'T&H' },
];
